import {createSelector} from '@reduxjs/toolkit'
import { LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION, LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL } from '../../app/constants'

const bltChangeReviewSelector = createSelector(
    [state => state.bltComponents, 
    state => state.archiveApplications.applications,
    state => state.additionalApplications
    ],
    (components, archiveApplications, additionalApplications) => {

        const queueItem = components.bltChangeReview.queueItem
        const archiveApplication = archiveApplications.filter(app => app.licenceNumber === queueItem?.licenceNumber)

        return {
            queueItem,
            archiveApplication : archiveApplication.length> 0 ? archiveApplication[0] : null,
            additionalBranchApplications : additionalApplications?.additionalBranchApplications ?? [],
            agentApplications : additionalApplications?.agentApplications ?? [],
            branchArchiveApplications : archiveApplications.filter(app => (
                                            app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                                            || app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL))
        }
    }
)

export const bltChangeReviewSelect = state => ({
    bltChangeReview : bltChangeReviewSelector(state)
})
